/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Downloads_TitleInputs */

const en_meta_downloads_title = /** @type {(inputs: Meta_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening - Downloads: Download Listening App: Academic Papers to Audio`)
};

const es_meta_downloads_title = /** @type {(inputs: Meta_Downloads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening - Descargas: Descarga la app Listening para artículos académicos en audio`)
};

/**
* | output |
* | --- |
* | "Listening - Downloads: Download Listening App: Academic Papers to Audio" |
*
* @param {Meta_Downloads_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const meta_downloads_title = /** @type {((inputs?: Meta_Downloads_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Downloads_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_meta_downloads_title(inputs)
	return en_meta_downloads_title(inputs)
});